import { withAITracking } from "@microsoft/applicationinsights-react-js";
import React from "react";
import { reactPlugin } from "../../../utilities/AppInsights";
import { AppState } from '../../../redux/store/store';
import { toggleLoading, toggleModalLoading, toggleAPIRequestSuccess } from '../../../redux/actions/system/actions';
import { getLoanApplicationDetails, addLoanDocument, deleteLoanDocument, findOpenDocumentRequests, uploadIdDocument } from '../../../redux/actions/loan/actions';
import { connect, ConnectedProps } from 'react-redux';
import LoadingSpinner from "shared/components/spinner/LoadingSpinner";
import SecondaryButton from "shared/components/SecondaryButton";
import LoanDocumentsSection from "../../../components/loanDetails/loanDocumentsSection/LoanDocumentsSection";
import FSAApplicationSection from "../../../components/loanDetails/FSAApplicationsSection/FSAApplicationsSection"
import OpenDocumentRequestsSection from "../../../components/loanDetails/openDocumentRequestsSection/OpenDocumentRequestsSection"
import LoanApplication from "models/loan/loanApplication";
import Container from "react-bootstrap/esm/Container";
import { DocumentType, IdDocumentSde, Subdomain } from "../../../shared/Enums";
import "./LoanDetailsPage.css"
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import AddDocumentModal from "../../../components/modals/addDocumentModal/AddDocumentModal";
import FSAApplicationModal from "../../../components/modals/fsaApplicationModal/FSAApplicationModal";
import LoanDocument from "models/loanDocument/loanDocument";
import AddDocumentsRequest from "models/addDocumentsRequest/AddDocumentsRequest";
import loanApplicationService from "accessors/loanApplicationService";
import LoanApplicationInformationSection from "../../../components/loanDetails/loanApplicationInformationSection/LoanApplicationInformationSection";
import FixedAssetSection from "../../../components/loanDetails/fixedAssetSection/FixedAssetSection";
import CollateralEquitySection from "../../../components/loanDetails/collateralEquitySection/CollateralEquitySection";
import RefinanceDebtSection from "../../../components/loanDetails/refinanceDebtSection/RefinanceDebtSection";
import OperatingLoanSection from "../../../components/loanDetails/operatingLoanSection/OperatingLoanSection";
import ApplicantSection from "../../../components/loanDetails/applicantSection/ApplicantSection";
import EntityApplicantSection from "../../../components/loanDetails/entityApplicantSection/EntityApplicantSection";
import LoanOfferSection from "../../../components/loanDetails/loanOffersSection/LoanOffersSection";
import DocumentRequest from "models/documentData/DocumentRequest";
import FSA2211 from "models/fsa2211Form/FSA2211";
import DealerPurchaseSection from "components/loanDetails/dealerPurchaseSection/DealerPurchaseSection";
import BalanceSheetSection from "components/loanDetails/balanceSheetSection/BalanceSheetSection";
import SubmittedBalanceSheet from "models/financialDocuments/balanceSheet/submittedBalanceSheet";
import BalanceSheetModal from "components/modals/balanceSheetModal/BalanceSheetModal";
import BalanceSheet from "models/financialDocuments/balanceSheet/balanceSheet";
import IdDocumentModal from "components/modals/idDocumentModal/IdDocumentModal";
import customerAccountService from "accessors/customerAccountService";
import DownloadDocumentResponse from "models/downloadDocumentResponse/DownloadDocumentResponse";
import IdDocumentUpload from "models/account/customer/idDocumentUpload/idDocumentUpload";
import IdDocumentsSection from "../../../components/loanDetails/idDocumentsSection/IdDocumentsSection";
import GapFinancingSection from "components/loanDetails/gapFinancingSection/GapFinancingSection";
import LendingReferenceSection from "components/loanDetails/lendingReferenceSection/LendingReferenceSection";
import ProductionLineOfCreditSection from "components/loanDetails/productionLineOfCreditSection/ProductionLineOfCreditSection";
import AuctionInformationSection from "components/loanDetails/auctionInformationSection/AuctionInformationSection";


const mapState = (state: AppState, route: any) => {
  const { system, loans } = state;
  const { isLoading, isModalLoading, apiRequestSuccess, subdomain } = system;
  const { loanApplicationDetails, openDocumentRequests } = loans;

  return {
    isLoading,
    isModalLoading,
    apiRequestSuccess,
    route,
    loanApplicationDetails,
    openDocumentRequests,
    subdomain
  };
};


const mapDispatch = {
  toggleLoading: (isLoading: boolean) => toggleLoading(isLoading),
  toggleModalLoading: (isModalLoading: boolean) => toggleModalLoading(isModalLoading),
  getLoanApplicationDetails: (loanId: number) => getLoanApplicationDetails(loanId),
  toggleAPIRequestSuccess: (apiRequestSuccess: boolean) => toggleAPIRequestSuccess(apiRequestSuccess),
  addLoanDocuments: (loanDocuments: AddDocumentsRequest) => addLoanDocument(loanDocuments),
  deleteLoanDocument: (loanDocumentId: number) => deleteLoanDocument(loanDocumentId),
  findOpenDocumentRequests: (customerAccountId: number) => findOpenDocumentRequests(customerAccountId),
  uploadIdDocument: (idDocumentUpload: IdDocumentUpload) => uploadIdDocument(idDocumentUpload)
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

type LoanDocumentAction = 'create' | 'download' | 'delete' | 'deny loan';
type IdDocumentModalAction = 'view' | 'upload';

interface LoanDetailsPageState {
  loanDetails: LoanApplication;
  showDocumentModal: boolean;
  showFSAApplicationModal: boolean;
  selectedLoanDocument: LoanDocument;
  addLoanDocumentsRequest: AddDocumentsRequest;
  documentModalAction?: LoanDocumentAction;
  selectedDownloadFile?: File;
  openDocumentRequests: DocumentRequest[];
  showBalanceSheetModal: boolean;
  selectedBalanceSheet: BalanceSheet;
  showIdDocumentModal: boolean;
  idDocumentBlob: string;
  idDocumentModalAction?: IdDocumentModalAction;
}

const dealerDocuments: DocumentType[] = [DocumentType.PhotoOfVin, DocumentType.PurchasePhoto, DocumentType.PurchaseOrderForm];

class LoanDetailsPage extends React.Component<Props, LoanDetailsPageState> {
  constructor(props: any) {
    super(props);

    this.state = {
      loanDetails: {} as LoanApplication,
      showFSAApplicationModal: false,
      showDocumentModal: false,
      addLoanDocumentsRequest: {} as AddDocumentsRequest,
      openDocumentRequests: this.props.openDocumentRequests,
      selectedLoanDocument: {} as LoanDocument,
      showBalanceSheetModal: false,
      selectedBalanceSheet: {} as BalanceSheet,
      showIdDocumentModal: false,
      idDocumentBlob: ''
    }
  }

  componentDidMount() {
    this.loadLoanDetails();
  }

  componentDidUpdate(previousProps: Props) {
    if (previousProps.loanApplicationDetails !== this.props.loanApplicationDetails) {
      if (this.props.loanApplicationDetails.customerAccount.balanceSheets != undefined && this.props.loanApplicationDetails.customerAccount.balanceSheets.length > 0) {
        this.props.loanApplicationDetails.customerAccount.balanceSheets.map((bs: SubmittedBalanceSheet) => bs.balanceSheet = JSON.parse(bs.balanceSheetData));
      }

      // if (this.props.subdomain === Subdomain.Dealer) {
      //   let loanDocuments: LoanDocument[] = [...this.props.loanApplicationDetails.customerAccount.loanDocuments ?? []];
      //   loanDocuments = loanDocuments?.filter((ld: LoanDocument) => ld.loanId === this.props.loanApplicationDetails.id);
      //   this.props.loanApplicationDetails.customerAccount.loanDocuments = [...loanDocuments];
      // }

      this.setState({ loanDetails: this.props.loanApplicationDetails });
    }

    if (previousProps.apiRequestSuccess !== this.props.apiRequestSuccess && this.props.apiRequestSuccess === true) {
      this.resetDocumentModalState();
      this.resetIdDocumentModalState();
    }

    if (previousProps.openDocumentRequests !== this.props.openDocumentRequests) {
      let documentRequests: DocumentRequest[] = [...this.props.openDocumentRequests ?? []];

      if (this.props.subdomain === Subdomain.Dealer) {
        documentRequests = documentRequests.filter((dr: DocumentRequest) => dr.loanId === this.props.loanApplicationDetails.id);
      }

      this.setState({ openDocumentRequests: documentRequests });
    }
  }

  loadLoanDetails() {
    this.props.toggleLoading(true);
    this.props.getLoanApplicationDetails(this.props.route.match.params.id);
  }

  resetBalanceSheetModalState(): void {
    // Resetting the modal values and setting the request success value back to false
    this.setState({ showBalanceSheetModal: false, selectedBalanceSheet: {} as BalanceSheet }, this.props.toggleAPIRequestSuccess.bind(this, false));
  }

  setBalanceSheetModalState(selectedBalanceSheet: BalanceSheet): void {
    this.setState({ showBalanceSheetModal: true, selectedBalanceSheet: selectedBalanceSheet });
  }

  acceptLoanOffer(loanOfferId: number, loanOfferIndex: number) {
    this.props.toggleLoading(true);

    loanApplicationService.AcceptLoanOffer(this.state.loanDetails.id, loanOfferId)
      .then(success => {
        this.props.toggleLoading(false);

        if (success) {
          let loanDetails = { ...this.state.loanDetails };

          if (loanDetails.loanOffers != undefined && loanDetails.loanOffers.length > 0) {
            loanDetails.loanOffers[loanOfferIndex].selected = true;
            this.setState({ loanDetails: loanDetails });
          }
        }
      })
  }

  rejectLoanOffer(loanOfferId: number, loanOfferIndex: number) {
    this.props.toggleLoading(true);

    loanApplicationService.RejectLoanOffer(this.state.loanDetails.id, loanOfferId)
      .then(rejected => {
        this.props.toggleLoading(false);

        if (rejected) {
          let loanDetails = { ...this.state.loanDetails };

          if (loanDetails.loanOffers != undefined && loanDetails.loanOffers.length > 0) {
            loanDetails.loanOffers[loanOfferIndex].expired = true;
            this.setState({ loanDetails: loanDetails });
          }
        }
      })
  }

  setDocumentModalState(action: LoanDocumentAction, selectedDocument?: LoanDocument, selectedFile?: File, documentType?: DocumentType): void {
    if (action === 'download') {
      this.setState({ showDocumentModal: true, documentModalAction: action, selectedDownloadFile: selectedFile, selectedLoanDocument: selectedDocument ?? {} as LoanDocument });
    } else {
      let document: LoanDocument = {} as LoanDocument;

      if (action === 'create') {
        document = {
          customerAccountId: this.state.loanDetails.customerAccount.id,
          documentName: '',
          loanId: this.state.loanDetails.id,
          type: documentType,
          year: dealerDocuments.includes(documentType ?? -1 as DocumentType) ? new Date().getFullYear().toString() : undefined
        } as LoanDocument;
      } else if (action === 'deny loan') {
        document = {
          customerAccountId: this.state.loanDetails.customerAccount.id,
          documentName: '',
          loanId: this.state.loanDetails.id,
          type: DocumentType.RegB,
          year: new Date().getFullYear().toString(),
          note: ''
        } as LoanDocument;
      } else if (action === 'delete') {
        document = selectedDocument ?? {} as LoanDocument;
      }

      this.setState({ documentModalAction: action, selectedLoanDocument: document }, this.showDocumentModal);
    }
  }

  showDocumentModal(): void {
    this.setState({ showDocumentModal: true });
  }

  setDocumentList(documents: AddDocumentsRequest) {
    this.setState({ addLoanDocumentsRequest: documents });
  }

  async addDocument(): Promise<void> {
    if (this.state.selectedLoanDocument !== undefined) {
      this.props.toggleModalLoading(true);

      switch (this.state.documentModalAction) {
        case 'create':
        case 'deny loan':
          this.props.addLoanDocuments(this.state.addLoanDocumentsRequest);
          break;

        case 'delete':
          if (this.state.selectedLoanDocument.id !== undefined) {
            this.props.deleteLoanDocument(this.state.selectedLoanDocument.id);
          }
          break;

        case 'download':
          if (this.state.selectedLoanDocument.id !== undefined) {
            var result = await loanApplicationService.DownloadLoanDocument(this.state.selectedLoanDocument.id);
            if (result.file) {
              this.downloadFile(result.file, result.fileName);
            }
          }
          this.props.toggleModalLoading(false);
          this.resetDocumentModalState();
          break;

        default:
          this.props.toggleModalLoading(false);
          break;
      }
    }
  }

  async saveFSA2211(formData: FSA2211): Promise<void> {
    if (formData !== undefined) {
      this.props.toggleModalLoading(true);
      formData.loanId = this.state.loanDetails.id;
      if (this.state.loanDetails.fsa2211?.id) {
        formData.id = this.state.loanDetails.fsa2211.id;
      }
      await loanApplicationService.SaveFSA2211(formData).then(result => {
        if (result) {
          var updatedLoanDetails = this.state.loanDetails;

          if (updatedLoanDetails.fsa2211) {
            updatedLoanDetails.fsa2211.data = formData.data;
          } else {
            updatedLoanDetails.fsa2211 = formData;
          }

          this.setState({ loanDetails: updatedLoanDetails }, this.props.toggleAPIRequestSuccess.bind(this, false))
          this.resetFSAApplicationModalState();
        }
      });
      this.props.toggleModalLoading(false);
    }
  }

  async generateFSA221Pdf(formData: FSA2211): Promise<void> {
    if (formData !== undefined) {
      this.props.toggleModalLoading(true);
      formData.loanId = this.state.loanDetails.id;
      if (this.state.loanDetails.fsa2211?.id) {
        formData.id = this.state.loanDetails.fsa2211.id;
      }
      await loanApplicationService.GenerateFSA2211Pdf(formData).then(result => {
        //update state
        var updatedLoanDetails = this.state.loanDetails;

        if (updatedLoanDetails.fsa2211) {
          updatedLoanDetails.fsa2211.data = formData.data;
        } else {
          updatedLoanDetails.fsa2211 = formData;
        }

        this.setState({ loanDetails: updatedLoanDetails }, this.props.toggleAPIRequestSuccess.bind(this, false))
        this.resetFSAApplicationModalState();

        //download the file
        if (result.file) {
          this.downloadFile(result.file, result.fileName);
        }
      });
      this.props.toggleModalLoading(false);
      this.resetFSAApplicationModalState();
    }
  }

  async downloadFSA221Pdf(): Promise<void> {

    this.props.toggleModalLoading(true);

    await loanApplicationService.DownloadFSA2211Pdf(this.state.loanDetails.id).then(result => {

      //download the file
      if (result.file) {
        this.downloadFile(result.file, result.fileName);
      }
    });
    this.props.toggleModalLoading(false);
    this.resetFSAApplicationModalState();
  }

  private downloadFile(file: Blob, fileName: string) {
    var fileURL = window.URL.createObjectURL(file);
    var a: HTMLAnchorElement = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute('style', "display: none");
    a.href = fileURL;
    a.download = fileName.split('"').join(''); // Fix to remove preceding and trailing "_" in the file name when being downloaded
    a.click();
  }

  resetDocumentModalState(): void {
    // Resetting the modal values and setting the request success value back to false
    this.setState({ showDocumentModal: false, documentModalAction: undefined, selectedLoanDocument: {} as LoanDocument }, () => {
      this.props.toggleAPIRequestSuccess.bind(this, false);
    });
  }

  openFSAApplicationModal(): void {
    this.setState({ showFSAApplicationModal: true }, () => { });
  }

  resetFSAApplicationModalState(): void {
    // Resetting the modal values and setting the request success value back to false
    this.setState({ showFSAApplicationModal: false }, () => { });
  }

  showIdDocumentModal(action: IdDocumentModalAction, documentId?: number, documentSide?: IdDocumentSde) {
    if (action === 'view') {
      this.props.toggleModalLoading(true);
      this.setState({ showIdDocumentModal: true, idDocumentModalAction: 'view' });

      customerAccountService.DownloadIdDocument(documentId ?? 0, documentSide ?? IdDocumentSde.Front)
        .then((result: DownloadDocumentResponse) => {
          this.props.toggleModalLoading(false);
          if (result.file) {
            let blobUrl = URL.createObjectURL(result.file);
            this.setState({ idDocumentBlob: blobUrl });
          }
        });
    } else if (action === 'upload') {
      this.setState({ showIdDocumentModal: true, idDocumentModalAction: 'upload' });
    }
  }

  uploadIdDocument(documentUpload: IdDocumentUpload) {
    this.props.toggleModalLoading(true);
    this.props.uploadIdDocument(documentUpload);
  }

  resetIdDocumentModalState(): void {
    this.setState({ showIdDocumentModal: false, idDocumentBlob: '' });
  }

  render() {
    return (
      <>
        <Container>
          {this.state.loanDetails !== undefined && Object.keys(this.state.loanDetails).length > 0 &&
            (<>
              <div className="loans-details-title-row">
                <Row className="align-items-center">
                  <Col md={6}>
                    <h1>Loan Details</h1>
                  </Col>
                </Row>
              </div>

              {/* Top Level Loan Application Information */}
              <div className="loan-application-details-section"></div>
              <LoanApplicationInformationSection
                loanDetails={this.state.loanDetails}
              />

              {/* Fixed Asset Items */}
              <div className="loan-application-details-section">
                <FixedAssetSection
                  loanDetails={this.state.loanDetails}
                />
              </div>


              {/* Dealer Purchase Items */}
              <div className="loan-application-details-section">
                <DealerPurchaseSection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Auction Information Items */}
              <div className="loan-application-details-section">
                <AuctionInformationSection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Gap Financing Items */}
              <div className="loan-application-details-section">
                <GapFinancingSection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Production Line of Credit Items */}
              <div className="loan-application-details-section">
                <ProductionLineOfCreditSection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Main Lending Reference Items */}
              <div className="loan-application-details-section">
                <LendingReferenceSection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Collateral Equity Items */}
              <div className="loan-application-details-section">
                <CollateralEquitySection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Refinance Debt Items */}
              <div className="loan-application-details-section">
                <RefinanceDebtSection
                  loanDetails={this.state.loanDetails}
                />
              </div>


              {/* Operating Loan Items */}
              <div className="loan-application-details-section">
                <OperatingLoanSection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Individual Applicants */}
              <div className="loan-application-details-section">
                <ApplicantSection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Entity Applicant */}
              <div className="loan-application-details-section">
                <EntityApplicantSection
                  loanDetails={this.state.loanDetails}
                />
              </div>

              {/* Open Document Requests */}
              {this.state.openDocumentRequests.length > 0 &&
                <div className="loan-application-details-section">
                  <OpenDocumentRequestsSection
                    openRequests={this.state.openDocumentRequests}
                  />
                </div>
              }

              <FSAApplicationSection
                openModal={this.openFSAApplicationModal.bind(this)} />

              {/* Loan Document Items */}
              <div className="loan-application-details-section">
                <LoanDocumentsSection
                  loanDetails={this.state.loanDetails}
                  setDocumentModalState={this.setDocumentModalState.bind(this)}
                />
                <SecondaryButton
                  buttonText={'Upload File'}
                  onClick={this.setDocumentModalState.bind(this, 'create')}
                />
              </div>

              <div>
                <IdDocumentsSection
                  loanDetails={this.state.loanDetails}
                  setIdDocumentModalState={this.showIdDocumentModal.bind(this)}
                />
              </div>

              {/* Balance Sheet Items */}
              <div className="loan-application-details-section">
                <BalanceSheetSection
                  loanDetails={this.state.loanDetails}
                  setBalanceSheetModalState={this.setBalanceSheetModalState.bind(this)}
                />
              </div>

              {/* Loan Offers */}
              <div className="loan-application-details-section">
                <LoanOfferSection
                  loanDetails={this.state.loanDetails}
                  acceptOfferCallback={this.acceptLoanOffer.bind(this)}
                  rejectOfferCallback={this.rejectLoanOffer.bind(this)}
                />
              </div>

              {/* Modals */}
              <FSAApplicationModal
                showModal={this.state.showFSAApplicationModal}
                loanDetails={this.state.loanDetails}
                applicationType="FSA2211"
                modalAction="create"
                isLoading={this.props.isModalLoading}
                fsa2211Form={this.state.loanDetails.fsa2211}
                onModalCancel={this.resetFSAApplicationModalState.bind(this)}
                onModalConfirm={this.saveFSA2211.bind(this)}
                onModalGenerate={this.generateFSA221Pdf.bind(this)}
                onModalDownload={this.downloadFSA221Pdf.bind(this)}
              />

              <AddDocumentModal
                showModal={this.state.showDocumentModal}
                modalAction={this.state.documentModalAction}
                customerId={this.state.loanDetails.customerAccount.id}
                loanId={this.state.loanDetails.id}
                defaultType={this.state.selectedLoanDocument?.type}
                defaultYear={this.state.selectedLoanDocument?.year}
                isLoading={this.props.isModalLoading}
                documentName={this.state.selectedLoanDocument?.documentName}
                documentListChange={this.setDocumentList.bind(this)}
                onModalCancel={this.resetDocumentModalState.bind(this)}
                onModalConfirm={this.addDocument.bind(this)}
              />

              <IdDocumentModal
                showModal={this.state.showIdDocumentModal}
                image={this.state.idDocumentBlob}
                isLoading={this.props.isModalLoading}
                modalAction={this.state.idDocumentModalAction ?? 'view'}
                customerAccountId={this.state.loanDetails.customerAccount.id}
                onModalCancel={this.resetIdDocumentModalState.bind(this)}
                onModalConfirm={this.uploadIdDocument.bind(this)}
              />

              {/* <ConfirmModal
                showModal={this.state.showConfirmModal}
                modalTitle={this.state.confirmModalTitle}
                modalMessage={this.state.confirmModalMessage}
                confirmButtonText={this.state.confirmButtonText}
                isDanger={this.state.confirmModalIsDanger}
                onModalCancel={this.resetConfirmModalState.bind(this)}
                onModalConfirm={this.confirmedCallback.bind(this)}
              /> */}

              {/* <OfferModal
                showModal={this.state.showLoanOfferModal}
                loanOffer={this.state.newLoanOffer}
                baseRate={this.state.loanDetails.bank.baseRate ?? 0}
                modalTitle={'Send Offer'}
                confirmButtonText={'Send Offer'}
                validData={this.validateLoanOfferData()}
                loanAmountChange={this.setLoanAmountValue.bind(this)}
                lendingLoanTypeChange={this.setLendingLoanTypeValue.bind(this)}
                interestTypeChange={this.setLoanOfferInterestTypeValue.bind(this)}
                periodicRateIncreaseChange={this.setPeriodicRateIncreaseValue.bind(this)}
                fixedInterestRateChange={this.setFixedInterestRate.bind(this)}
                loanTermChange={(termAmount) => this.setLoanTerms(termAmount, LoanTermType.Years)}
                variableInterestRateChange={this.setVariableInterestRate.bind(this)}
                expirationDateCallback={this.setExpirationDate.bind(this)}
                onModalCancel={this.resetLoanOfferModalState.bind(this)}
                onModalConfirm={this.saveLoanOffer.bind(this)}
              /> */}

              <BalanceSheetModal
                showModal={this.state.showBalanceSheetModal}
                modalTitle={'Balance Sheet'}
                balanceSheet={this.state.selectedBalanceSheet}
                onBalanceSheetChange={() => { }}
                onModalCancel={this.resetBalanceSheetModalState.bind(this)}
                onModalConfirm={this.resetBalanceSheetModalState.bind(this)}
              />
            </>)
          }
        </Container>
        {this.props.isLoading &&
          <LoadingSpinner
            variant={'dark'}
            animation={'border'}
          />
        }
      </>
    );
  }
}

export default withAITracking(reactPlugin, connector(LoanDetailsPage));
